import useEmployerJobs from "hooks/useEmployerJobs";
import useInputChange from "hooks/useInputChange";
import useUsers from "hooks/useUsers";
import { FormEvent } from "react";
import { MyndaType } from "shared";
import { CreateBookingInput } from "types/booking.interface";

interface Props {
  onSubmit: (record: CreateBookingInput) => void;
  isLoading?: boolean;
  onCancel: () => void;
}
export default function BookingForm({ onSubmit, isLoading, onCancel }: Props) {
  const { state, onChange, onChangeByNameValue } =
    useInputChange<CreateBookingInput>({
      bookingType: "",
      myndaUser: "",
      job: "",
      employerUser: "",
      amount: 0,
    });
  const { data: myndas } = useUsers({ page: 1, limit: 500, search: "Mynda" });
  const { data: employers } = useUsers({
    page: 1,
    limit: 500,
    search: "Employer",
  });
  const { data: jobs } = useEmployerJobs(state?.employerUser, 500);

  const handleSubmit = (e: FormEvent) => {
    const job = jobs?.find((job) => job._id === state.job);
    e.preventDefault();

    const payload: CreateBookingInput = {
      ...state,
      bookingType: job ? job.jobType : MyndaType.LeaveIn,
    };

    onSubmit(payload);
  };

  const handleJobBlur = () => {
    if (state.job) {
      const job = jobs?.find((job) => job._id === state.job);

      onChangeByNameValue("amount", job?.maxSalary ?? 0);
    }
  };

  return (
    <form action="#!" onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Select Mynda
        </label>
        <select
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          name="myndaUser"
          onChange={onChange}
          value={state.myndaUser}
          required
        >
          <option value="">Select-</option>
          {myndas?.data?.data?.map((user) => (
            <option key={user._id} value={user._id}>
              {user.firstName} {user.lastName}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Select Employer
        </label>
        <select
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          name="employerUser"
          onChange={onChange}
          value={state.employerUser}
          required
        >
          <option value="">Select-</option>
          {employers?.data?.data?.map((user) => (
            <option key={user._id} value={user._id}>
              {user.firstName} {user.lastName}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Select Employer Job
        </label>
        <select
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          name="job"
          onChange={onChange}
          value={state.job}
          onBlur={handleJobBlur}
        >
          <option value="">Select-</option>
          {jobs?.map((job) => (
            <option key={job._id} value={job._id}>
              {job.title}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Amount
        </label>
        <input
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          name="amount"
          onChange={onChange}
          value={state.amount}
          required
        />
      </div>

      <div className="flex justify-end gap-2 mt-4">
        <button
          type="reset"
          data-modal-close="addDocuments"
          className="px-4 py-2 text-sm rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-60 transition-colors"
        >
          {isLoading ? "Loading..." : "Submit"}
        </button>
      </div>
    </form>
  );
}
